import React from "react";
import Helmet from "react-helmet";
import { Portada } from "../components/molecules/Portada";

import "../css/Contactos.css";
import { useLocation } from "react-router-dom";
import { AcceptTermsDetail } from "../components/molecules/AcceptTerms";

export const AcceptTerms = () => {
  const { search } = useLocation();
  const approvalConfirmationId = new URLSearchParams(search).get('approvalConfirmationId');

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>¡Tu crédito va en camino!</title>
        <meta name="description" content="Confirmación de solicitud" />
      </Helmet>
      <Portada className="c-block-3" Name="¡Tu crédito va en camino!" id="contact" />
      <div className="c-block-4">
        <AcceptTermsDetail approvalConfirmationId={approvalConfirmationId} />
      </div>
    </>
  );
};
